// src/pages/guia/GuiaLayout.js
//
// Layout del panel del Guía: sidebar con panel, afiliados, mapa,
// comisiones, liquidaciones y perfil.

import React from 'react';
import { Outlet, useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import {
  Box, AppBar, Toolbar, Typography, Drawer, List, ListItem, ListItemButton,
  ListItemIcon, ListItemText, IconButton, Avatar, Menu, MenuItem,
} from '@mui/material';
import DashboardIcon    from '@mui/icons-material/Dashboard';
import StorefrontIcon   from '@mui/icons-material/Storefront';
import MapIcon          from '@mui/icons-material/Map';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import PaymentsIcon     from '@mui/icons-material/Payments';
import PersonIcon       from '@mui/icons-material/Person';
import LogoutIcon       from '@mui/icons-material/Logout';

import { useApp } from '../../context/AppContext';

const drawerWidth = 220;

const items = [
  { path: '/guia',               label: 'Panel',        icon: <DashboardIcon /> },
  { path: '/guia/afiliados',     label: 'Mis negocios', icon: <StorefrontIcon /> },
  { path: '/guia/mapa',          label: 'Mapa de zona', icon: <MapIcon /> },
  { path: '/guia/comisiones',    label: 'Comisiones',   icon: <RequestQuoteIcon /> },
  { path: '/guia/liquidaciones', label: 'Liquidaciones', icon: <PaymentsIcon /> },
  { path: '/guia/perfil',        label: 'Mi perfil',    icon: <PersonIcon /> },
];

export default function GuiaLayout() {
  const { sesionBackend, cerrarSesionBackend } = useApp();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuAnchor, setMenuAnchor] = React.useState(null);

  const salir = async () => {
    setMenuAnchor(null);
    await cerrarSesionBackend();
    navigate('/login', { replace: true });
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" elevation={0}
              sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px`,
                    bgcolor: '#fff', color: '#0F4C3A', borderBottom: '1px solid #eee' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, fontFamily: 'Fraunces', fontWeight: 700 }}>
            HolaVeci — Guía
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
            {sesionBackend?.correo}
          </Typography>
          <IconButton onClick={(e) => setMenuAnchor(e.currentTarget)}>
            <Avatar sx={{ width: 32, height: 32, bgcolor: '#0F4C3A' }}>
              {(sesionBackend?.nombre?.[0] || 'G').toUpperCase()}
            </Avatar>
          </IconButton>
          <Menu anchorEl={menuAnchor} open={!!menuAnchor} onClose={() => setMenuAnchor(null)}>
            <MenuItem onClick={salir}>
              <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
              Cerrar sesión
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent"
              sx={{ width: drawerWidth, flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box',
                                              bgcolor: '#0F4C3A', color: '#F5EFE0' } }}>
        <Toolbar sx={{ px: 3 }}>
          <Typography variant="h6" sx={{ fontFamily: 'Fraunces', fontWeight: 700 }}>
            ¡Hola guía!
          </Typography>
        </Toolbar>
        <List sx={{ px: 1 }}>
          {items.map((it) => {
            const activo = location.pathname === it.path;
            return (
              <ListItem key={it.path} disablePadding sx={{ mb: 0.5 }}>
                <ListItemButton component={RouterLink} to={it.path} selected={activo}
                  sx={{ borderRadius: 1, color: '#F5EFE0',
                        '&.Mui-selected': { bgcolor: 'rgba(245,239,224,0.16)' },
                        '&:hover': { bgcolor: 'rgba(245,239,224,0.08)' } }}>
                  <ListItemIcon sx={{ color: '#F5EFE0', minWidth: 36 }}>{it.icon}</ListItemIcon>
                  <ListItemText primary={it.label} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, bgcolor: '#FBF7F0', minHeight: '100vh' }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
